/**
 * Treatment category badge component
 *
 * Renders a color-coded Badge for a treatment category value.
 * Used on AppointmentCard and TransactionCard to display
 * the resolved treatment classification.
 */

import { Badge, type ColorStyles } from 'app/components/Badge'
import { TreatmentCategory, UNCATEGORIZED, type CodeCategory } from 'lib/cdtCodeDefaults'

/** Color mapping — each treatment category has a distinct badge color */
const categoryColors: Record<CodeCategory, ColorStyles> = {
  [TreatmentCategory.DIAGNOSTIC]: `sky`,
  [TreatmentCategory.PREVENTATIVE]: `green`,
  [TreatmentCategory.RESTORATIVE]: `blue`,
  [TreatmentCategory.ENDODONTICS]: `purple`,
  [TreatmentCategory.PERIODONTICS]: `amber`,
  [TreatmentCategory.PROSTHODONTICS_REMOVABLE]: `blue`,
  [TreatmentCategory.MAXILLOFACIAL_PROSTHETICS]: `amber`,
  [TreatmentCategory.IMPLANT_SERVICES]: `purple`,
  [TreatmentCategory.PROSTHODONTICS_FIXED]: `blue`,
  [TreatmentCategory.ORAL_MAXILLOFACIAL_SURGERY]: `red`,
  [TreatmentCategory.ORTHODONTICS]: `sky`,
  [TreatmentCategory.ADJUNCTIVE_GENERAL_SERVICES]: `gray`,
  [UNCATEGORIZED]: `gray`,
}

export function TreatmentCategoryBadge({ category }: { category: CodeCategory }) {
  return <Badge label={category} color={categoryColors[category]} />
}
